// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "FundCard-module--arrow-up-and-down--88b9a";
export var assets = "FundCard-module--assets--2a354";
export var bar = "FundCard-module--bar--f7f8a";
export var carouselCard = "FundCard-module--carouselCard--5f02b";
export var divider = "FundCard-module--divider--b1338";
export var fiveBarFill = "FundCard-module--fiveBarFill--a9b8d";
export var fourBarFill = "FundCard-module--fourBarFill--49b57";
export var fundCardContainer = "FundCard-module--fundCardContainer--903a4";
export var investmentRiskBarsContainer = "FundCard-module--investmentRiskBarsContainer--efb4a";
export var investmentRiskLabels = "FundCard-module--investmentRiskLabels--b634d";
export var investmentRiskTitle = "FundCard-module--investmentRiskTitle--1361b";
export var link = "FundCard-module--link--ad6de";
export var metric = "FundCard-module--metric--c6ea1";
export var metricsContainer = "FundCard-module--metricsContainer--cb4d6";
export var metricsWrapper = "FundCard-module--metricsWrapper--0dfb3";
export var oneBarFill = "FundCard-module--oneBarFill--cb7ef";
export var sevenBarFill = "FundCard-module--sevenBarFill--ef5eb";
export var sixBarFill = "FundCard-module--sixBarFill--02fcc";
export var symbol = "FundCard-module--symbol--29702";
export var tableContainer = "FundCard-module--tableContainer--fa9b9";
export var tableRow = "FundCard-module--tableRow--fcbc4";
export var tableRowInfo = "FundCard-module--tableRowInfo--4639c";
export var tableRowsContainer = "FundCard-module--tableRowsContainer--16de2";
export var tableTitle = "FundCard-module--tableTitle--28f2c";
export var tableTitlesContainer = "FundCard-module--tableTitlesContainer--5f0ad";
export var text = "FundCard-module--text--d9bcc";
export var threeBarFill = "FundCard-module--threeBarFill--b67b9";
export var title = "FundCard-module--title--05066";
export var top5HoldingsContainer = "FundCard-module--top5HoldingsContainer--01310";
export var top5HoldingsTitle = "FundCard-module--top5HoldingsTitle--22344";
export var twoBarFill = "FundCard-module--twoBarFill--e785c";
export var withMarginBottom = "FundCard-module--withMarginBottom--ab4eb";